module.exports = __webpack_public_path__ + "static/media/27-8.366d8c49.mp3";